var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marquee-text"},[_c('span',{ref:"text",staticClass:"marquee-text__content",class:{'marquee-text__content--scrollable': _vm.scrollable},style:(_vm.scrollable ? _vm.styles : {})},[_vm._v(_vm._s(_vm.text)),(_vm.scrollable)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }